module.exports = __webpack_public_path__ + "static/media/nl.fc2858c5.svg";